import React, { ReactNode } from 'react';
import './css/indexModal.css'

interface ModalProps {
    isOpen: boolean;
    closeModal?: () => void;
    children: ReactNode;
    withWindows: string;
}

const ModalComponent: React.FC<ModalProps> = ({ isOpen, children, withWindows }) => {
    return (
        <div>
            {isOpen && (
                <div className="fixed z-10 inset-0 overflow-y-auto w-full bg-modal">
                    <div className='flex items-center justify-center min-h-screen'>
                        <div className={`relative bg-white rounded-lg`} style={{ width: withWindows}}>
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModalComponent;